// commandbar can only render strings, not react components
export function getCommandBarIcon(src: string) {
  return `<img src="${src}" width="24" height="24"/>`;
}
